
type Props = {}

const SetUpFinish = (props: Props) => {
  return (
    <div>SetUpFinish</div>
  )
}

export default SetUpFinish